"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveAppPageDelivery = resolveAppPageDelivery;
const app_base_config_1 = require("./app-base-config");
const app_base_contract_1 = require("./app-base-contract");
const app_page_access_1 = require("./app-page-access");
/** Everyone who may reach a page: a visitor, a portal person, a member. */
const APP_PAGE_DELIVERY_PRINCIPALS = [
    { kind: 'visitor' },
    { kind: 'portal', groupIds: [] },
    { kind: 'member', groupIds: [], role: 'write' },
];
/**
 * The tables a page works on: the ones it shows and the ones of every action
 * somebody may use on it. A group of rows whose App is gone is admitted to
 * nobody (appPageActionDecision).
 */
function appPageDeliveryTables(appBaseConfig, route) {
    const sourceKeys = new Set(route.dataSourceKeys);
    for (const action of appBaseConfig.appBase?.actions ?? []) {
        // An automation runs without a page.
        if (action.type === 'automationRun')
            continue;
        const admitted = APP_PAGE_DELIVERY_PRINCIPALS.some(principal => (0, app_base_config_1.appPageActionDecision)({
            appBaseConfig,
            action,
            routePath: route.path,
            principal,
        }).entry === 'open');
        if (!admitted)
            continue;
        for (const table of (0, app_base_config_1.appActionTableOperations)(appBaseConfig, action))
            sourceKeys.add(table.sourceKey);
    }
    return [...sourceKeys];
}
/**
 * A page is served statically when it is a page of the manifest, everyone
 * reaches it only as the public, it reads every table it works on fully and
 * nobody can change or delete there. Visitors may still create rows (a
 * public form): reading stays static, only the submit goes to the backend
 * through the action endpoint. Whatever the page cannot prove goes through
 * the backend.
 */
function resolveAppPageDelivery(input) {
    const { appBaseConfig, route } = input;
    const path = (0, app_base_contract_1.normalizeAppRoutePath)(route.path);
    if (!appBaseConfig.appBase?.routes.some(candidate => (0, app_base_contract_1.normalizeAppRoutePath)(candidate.path) === path))
        return 'backend';
    // Agent Actions of a page run for signed-in members only.
    if (route.agentActionIds.length > 0)
        return 'backend';
    const sourceKeys = appPageDeliveryTables(appBaseConfig, route);
    const [visitor, ...others] = APP_PAGE_DELIVERY_PRINCIPALS.map(principal => (0, app_page_access_1.resolveAppPageAccess)({
        section: appBaseConfig.pageAccess,
        routePath: route.path,
        sourceKeys,
        principal,
    }));
    if (visitor.entry !== 'open')
        return 'backend';
    if (others.some(decision => decision.actsAs !== 'public'))
        return 'backend';
    return sourceKeys.every(sourceKey => {
        const table = visitor.tables[sourceKey];
        return (table?.readFilter === 'all' &&
            table.updateFilter === null &&
            table.deleteFilter === null);
    })
        ? 'static'
        : 'backend';
}
